<template>
  <div>
    <modal :name="`modal-custom-options-${product.sku}${modalCategoryId}`" @isModalOpen="overlayState" source="custom_options" :width="520">
      <p class="h3" slot="header">
        {{ $t('Order configurator') }}
      </p>
      <div slot="content">
        <product-custom-options ref="options" :style="{'max-height': `${heightForForm}px`}" :class="{'scroll': isShowScroll}" :product="product" />
        <div class="row center-xs">
          <add-to-cart class="configurator-button col-xs-12 col-sm-4 col-md-6 list-button h5 py10 center-xs"
                       :product="productToAdd"
                       :disabled="!productToAdd"
                       :categoryId="categoryId"
          />
        </div>
      </div>
    </modal>
    <div class="overlay" v-if="isOverlayVisible"></div>
  </div>
</template>
<script>
import ProductCustomOptions from 'theme/components/core/ProductCustomOptions.vue'
import Modal from 'theme/components/core/Modal.vue'
import AddToCart from 'theme/components/core/AddToCart'
import { isServer } from '@vue-storefront/core/helpers'

export default {
  name: 'Configurator',
  components: {
    ProductCustomOptions,
    Modal,
    AddToCart
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    categoryId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      productToAdd: null,
      isOverlayVisible: false
    }
  },
  mounted () {
    this.productToAdd = this.product
    this.$bus.$on('product-after-customoptions', this.onAfterCustomOptionsChanged)
  },
  computed: {
    heightForForm () {
      if (isServer) {
        return 500
      }
      if (window.innerWidth <= 600) {
        return window && window.innerHeight - 220
      }
      return window && window.innerHeight - 300
    },
    isShowScroll () {
      let numberOptions = 0
      if (this.product.custom_options && this.product.custom_options.length && this.product.custom_options.filter(option => option.is_active === 1).length) {
        this.product.custom_options.forEach(option => {
          if (option.type === 'checkbox' || option.type === 'select' || option.type === 'drop_down') {
            numberOptions += option.is_active && option.values && option.values.length ? option.values.length : 0
          }
        })
      }
      return numberOptions > 4 || (this.product.custom_options && this.product.custom_options.filter(option => option.is_active === 1).length > 4)
    },
    modalCategoryId () {
      return this.categoryId ? `-${this.categoryId}` : ''
    }
  },
  methods: {
    overlayState (state) {
      document.body.style.overflowY = state ? 'hidden' : ''
      this.isOverlayVisible = state
    },
    onAfterCustomOptionsChanged (payload) {
      let priceDelta = 0
      let priceDeltaInclTax = 0
      let optionsToProduct = []
      for (const optionValue of Object.values(payload.optionValues)) {
        optionsToProduct.push(optionValue)
        if (typeof optionValue === 'object' && parseInt(optionValue.option_type_id) > 0) {
          if (optionValue.price_type === 'fixed' && optionValue.price !== 0) {
            priceDelta += optionValue.price
            priceDeltaInclTax += optionValue.price
          }
          if (optionValue.price_type === 'percent' && optionValue.price !== 0) {
            priceDelta += ((optionValue.price / 100) * product.price)
            priceDeltaInclTax += ((optionValue.price / 100) * product.priceInclTax)
          }
        }
      }

      if (payload && this.product && payload.product.entity_id === this.product.entity_id) {
        this.productToAdd = Object.assign({}, this.product, {selected_options: optionsToProduct})
        this.productToAdd.price = this.product.price + priceDelta
        this.productToAdd.originalPriceInclTax = this.product.priceInclTax + priceDeltaInclTax
        this.productToAdd.regular_price = this.product.priceInclTax + priceDeltaInclTax
        this.productToAdd.priceInclTax = this.product.priceInclTax + priceDeltaInclTax
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('product-after-customoptions', this.onAfterCustomOptionsChanged)
  }
}
</script>
<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3;
}

.scroll {
  overflow-y: auto;
}

.configurator-button {
  @media (max-width: 600px) {
    position: absolute;
    bottom: 20px;
    width: 90%;
    margin: 0 auto;
  }
}
</style>
<style>
  .modal {
    z-index: 1001;
  }
</style>
